export default (promptOutput, isRunning, links) => ({
    promptOutput,
    isRunning,
    links,
    outputContainerHeight: '100px',
    playgroundContainerHeight: '100%',
    get formattedOutput() {
        if (!this.promptOutput?.output) {
            return null;
        }

        let output = this.promptOutput.output;

        /**
         * Escapes regex special characters in a string,
         * so it can be safely used as a literal inside `new RegExp()`.
         *
         * Example: "a+b(c)" → "a\+b\(c\)"
         */
        const escapeRegExp = (string) =>  string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        const keys = Object.keys(this.links || {}).sort((a, b) => b.length - a.length);

        keys.forEach((link) => {
            const href = this.links[link];

            if (!href) return;

            const escaped = escapeRegExp(link);

            const pattern = new RegExp(`(^|[^A-Za-z0-9#])(${escaped})(?![A-Za-z0-9])`, 'g');

            output = output.replace(
                pattern,
                (match, boundaryChar, questionCode) => `${boundaryChar}<a class="text-primary-base" target="_blank" rel="noopener noreferrer" href="${escapeHtmlAttribute(href)}">${questionCode}</a>`);
        });

        output = output.replace(/\\n/g, '\n');

        return renderSafeMarkdown(output);
    },
    get formattedCreatedAt () {
        return this.promptOutput ? date(this.promptOutput.created_at).combinationDateAndTime() : null;
    },
    run() {
        if (!this.isRunning) {
            this.$wire.run();
        }
    },
    handlePromptOutputCreated() {
        this.promptOutput.output = '';

        Echo.private(`prompt-output.${this.promptOutput.id}.running`)
            .listen('PromptOutput.Running', (e) => {
                const container = this.$refs['output-label-' + this.promptOutput.id];

                this.promptOutput.output += e.response;

                if (!container) {
                    return;
                }

                container.innerHTML = this.formattedOutput;
            });

        Echo.private(`prompt-output.${this.promptOutput.id}.finished`)
            .listen('PromptOutput.Finished', (e) => {
                this.isRunning = false;

                this.$dispatch('prompt-output::finished', { promptOutput: this.promptOutput.id });
            })
    },
    setPlaygroundContainerHeight() {
        const playgroundContainer = this.$refs.playgroundContainer;

        if (!playgroundContainer) {
            return;
        }

        if (window.innerWidth < 768) {
            this.playgroundContainerHeight = '100%';
            return;
        }

        this.playgroundContainerHeight = `${playgroundContainer.clientHeight}px`;
    },
    initFormContainerResizeObserver() {
        const formContainer = this.$refs.formContainer;

        if (!formContainer) {
            return;
        }

        const resizeObserver = new ResizeObserver(() => {
            this.outputContainerHeight = `${formContainer.clientHeight}px`;
        });

        resizeObserver.observe(formContainer);
    },
    init() {
        this.initFormContainerResizeObserver();

        this.$nextTick(() => {
            requestAnimationFrame(() => {
                this.setPlaygroundContainerHeight();
            });
        });

        this.$wire.on('cancel-prompt-output-listeners', (event) => {
            const id = event.promptOutputId;

            Echo.private(`prompt-output.${id}.running`).stopListening('PromptOutput.Running');
            Echo.private(`prompt-output.${id}.finished`).stopListening('PromptOutput.Finished');
        });
    }
});
